import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CodeScanner.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { ExtraHelpers } from "../../more/Helpers";
import { BarcodeFormat, GlobalCodeScanner, ICodeScanner, ScannerResult } from "./BundleTypes/CodeScannerTypes";
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';

class CodeScanner extends compose(_WidgetBaseSP) {
  templateString: any = template;

  private isReady = false;
  private callbackIsReady: Function|null = null;
  private videoContainer:HTMLDivElement;
  private VideoSelect: MdsLax<InstanceType<typeof SelectBox>>;
  private devices: Array<{ device: MediaDeviceInfo, id: string, label:string }> = [];
  private actualScanner:ICodeScanner;
  private refresh_devices_btn:HTMLButtonElement;

  private noCamPlaceholder:HTMLDivElement;
  private isScanningRightNow = false;

  postCreate(): void {
    super.postCreate.apply(this, arguments as any);
    this.VideoSelect.setLabel(this.translate("CodeScanner_SelectVideoDeviceLabel"));
    this.VideoSelect.setBlankOption(null, this.translate("CodeScanner_NoCameraSelected"), false); //TODO -  translations
    this.refresh_devices_btn.addEventListener("click", lang.hitch(this, this.refreshVideoDevices));
    ExtraHelpers.sideLoadResource(window.appRoot + "Content/code_scanner/code-scanner.bundle.js", 'js').then(
      ()=>{
        if (typeof (window as any as GlobalCodeScanner).CodeScanners != 'undefined'){
          this.readyWidget().then(()=>{
            this.isReady = true;
            this.refresh_devices_btn.disabled = false;
            if (this.callbackIsReady != null){
              this.callbackIsReady();
            }
          });
        }
      }
    );
  }

  private async readyWidget(){
    await this.refreshVideoDevices();
    this.actualScanner = (window as any as GlobalCodeScanner).CodeScanners.Get();
  }

  private async refreshVideoDevices(){
    let vd = await (window as any as GlobalCodeScanner).CodeScanners.listVideoDevices();
    let actualNewVals: Array<{ device: MediaDeviceInfo, id: string, label:string }> = [];
    for (let vdelem of vd){
      actualNewVals.push({
        device:vdelem,
        label: vdelem.label ?? vdelem.deviceId ?? vdelem.kind ?? this.translate("CodeScanner_UnbekanntesGeraet") ?? "UNKNOWN DEVICE",
        id: vdelem.deviceId ?? await this.helper_sha256(JSON.stringify(vdelem))
      });
    }
    this.devices = actualNewVals;

    let oldSelection:string|null = this.VideoSelect.getValue();

    this.VideoSelect.setData(oldSelection ?? null, this.devices, "id", "label", true );
  }

  startup(): void {
    super.startup.apply(this, arguments as any);
  }

  /**
   * Führt den übergebenen Callback aus, sobald der Scanner initialisiert und bereit ist.
   * @param callback Die Funktion, die aufgerufen werden soll.
   */
  public onScannerIsReady(callback:Function){
    if (this.isReady){
      callback();
    }else{
      this.callbackIsReady = callback;
    }
  }

  /**
   * Startet den Scanvorgang mit der aktuell ausgewählten Kamera.
   * @param scanFor Das Barcode-Format, nach dem gesucht werden soll (oder null under der Scanner probiert das Format zu erraten. Nicht empfohlen, da schlechte performance).
   * @param callback Die Funktion, die bei einem erfolgreichen Scan mit dem Ergebnis aufgerufen wird.
   * @returns Ein Promise, das true zurückgibt, wenn der Scanvorgang gestartet werden konnte, andernfalls false.
   */
  public async startScanning(scanFor: BarcodeFormat | null, callback: (result: ScannerResult) => any): Promise<boolean>{
    if (this.isReady == false){
      return false;
    }
    let cam: { device: MediaDeviceInfo, id: string, label: string } | null = this.VideoSelect.getValue();
    if (typeof cam == 'undefined' || cam == null){
      return false;
    }
    if (this.isScanningRightNow){
      await this.stopScanning();
    }
    await this.actualScanner.startScanning(this.videoContainer, cam.device, callback, scanFor ?? 100)
    this.isScanningRightNow = true;
    this.VideoSelect.setReadonly(true);
    this.refresh_devices_btn.disabled = true;
    this.noCamPlaceholder.classList.add("w3-hide");
    return true;
  }

  /**
   * Stoppt den laufenden Scanvorgang und gibt die Kamera sowie die UI-Elemente wieder frei.
   */
  public async stopScanning(){
    await this.actualScanner.stopScanning();
    this.VideoSelect.setReadonly(false);
    this.refresh_devices_btn.disabled = false;
    this.isScanningRightNow = false;
    this.noCamPlaceholder.classList.remove("w3-hide");
  }

  private async helper_sha256(message:string) {
    // Wegen security hat manche Geräte keine Hardware ID, deshalb koennen wir uns eine hier Wuerfeln YAY WORKAROUNDS! :)
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }

  destroy(): void {
    this.stopScanning();
    super.destroy.apply(this, arguments as any);
  }
}

export default mdsWidget(CodeScanner);
